import React, { PureComponent } from "react";
import _ from "lodash";
import { Translate } from "react-redux-i18n";
import evio from "../../../styles/images/evio.svg";
import calendar from "../../../styles/images/calendar.svg";
import { roundToDecimals, momentModule, parseAddress } from "../../utils/Utils";

const { formatDate } = momentModule;

class ReportDetail extends PureComponent {
  componentDidUpdate(prevProps, prevState) {
    const style = document.createElement("style");
    style.innerHTML = `@page {size: 297mm 210mm}`;
    style.id = "page-orientation";
    document.head.appendChild(style);
  }

  renderTitle() {
    return (
      <div className="title">
        {this.props.type === "chargers" ? (
          <Translate value="report_chargerSession" />
        ) : (
          <Translate value="report_evSession" />
        )}
        <span>-</span>
        <span>
          {this.props.type === "chargers"
            ? this.props.data?.charger?.name
              ? this.props.data?.charger?.name
              : ""
            : this.props.data?.ev?.licensePlate
            ? this.props.data?.ev?.licensePlate
            : ""}
        </span>
      </div>
    );
  }

  renderTable() {
    return (
      <div className="kpi-table-container">
        <table className="table table-sm">
          <thead className="table-header">
            <tr className="row no-gutters">
              {this.props.data?.costDetails ? (
                <>
                  <th className="col title">
                    <Translate value="chargerSessionSummary_durationTime" />
                  </th>
                  <th className="col title">
                    <Translate value="chargerSessionSummary_totalChargingTime" />
                  </th>
                  <th className="col title">
                    <Translate value="chargerSessionSummary_energySupplied" />
                  </th>
                  <th className="col title">
                    <Translate value="chargerSessionSummary_activationFee" />
                  </th>
                  <th className="col title">
                    <Translate value="chargerSessionSummary_costDuringCharge" />
                  </th>
                  <th className="col title">
                    <Translate value="chargerSessionSummary_parkingDuringCharging" />
                  </th>
                  <th className="col title">
                    <Translate value="chargerSessionSummary_parking" />:
                  </th>
                </>
              ) : (
                <>
                  <th className="col title">
                    <Translate value="chargerSessionSummary_totalChargingTime" />
                  </th>
                  <th className="col title">
                    <Translate value="chargerSessionSummary_energySupplied" />
                  </th>
                  <th className="col title">
                    <Translate value="chargingSessionSummaryMobie_opc" />
                  </th>
                  <th className="col title">
                    <Translate value="chargingSessionSummaryMobie_activation" />{" "}
                    <Translate value="chargingSessionSummaryMobie_opc" />
                  </th>
                  <th className="col title">
                    <Translate value="chargingSessionSummaryMobie_time" />{" "}
                    <Translate value="chargingSessionSummaryMobie_opc" />
                  </th>
                  <th className="col title">
                    <Translate value="chargingSessionSummaryMobie_energy" />{" "}
                    <Translate value="chargingSessionSummaryMobie_opc" />
                  </th>
                  <th className="col title">
                    <Translate value="chargingSessionSummaryMobie_ceme" />
                  </th>
                  <th className="col title">
                    <Translate value="chargingSessionSummaryMobie_activation" />{" "}
                    <Translate value="chargingSessionSummaryMobie_ceme" />
                  </th>
                  <th className="col title">
                    <Translate value="chargingSessionSummaryMobie_time" />{" "}
                    <Translate value="chargingSessionSummaryMobie_ceme" />
                  </th>
                  <th className="col title">
                    <Translate value="chargingSessionSummaryMobie_energy" />{" "}
                    <Translate value="chargingSessionSummaryMobie_ceme" />
                  </th>
                  <th className="col title">
                    <Translate value="chargingSessionSummaryMobie_fees" />
                  </th>
                  <th className="col title">
                    <Translate value="chargingSessionSummaryMobie_iec" />
                  </th>
                  <th className="col title">
                    <Translate value="chargingSessionSummaryMobie_tar" />
                  </th>
                  <th className="col title">
                    <Translate value="chargingSessionSummaryMobie_vat" />
                  </th>
                </>
              )}
              <th className="col title">Total:</th>
            </tr>
          </thead>
          <tbody className="table-values">
            <tr className="row no-gutters">
              {this.props.data?.costDetails ? (
                <>
                  <td className="col">
                    {this.props.data.timeChargedInMin || 0}
                  </td>
                  <td className="col">{this.props.data.totalTimeInMin || 0}</td>
                  <td className="col">
                    {!Number.isNaN(this.props.data.costDetails.totalPower)
                      ? `${
                          this.props.data.costDetails.totalPower > 1000
                            ? `${roundToDecimals(
                                this.props.data.costDetails.totalPower / 1000,
                                2
                              )}kWh`
                            : `${roundToDecimals(
                                this.props.data.costDetails.totalPower,
                                2
                              )}Wh`
                        }`
                      : "-"}
                  </td>

                  <td className="col">
                  {this.props.data.costDetails.activationFee != null
                  ? roundToDecimals(this.props.data.costDetails.activationFee, 2) + " €"
                  : "-"}
                  </td>
                  <td className="col">
                  {this.props.data.costDetails.costDuringCharge != null
                  ? roundToDecimals(this.props.data.costDetails.costDuringCharge, 2) + " €"
                  : "-"}
                  </td>
                  <td className="col">
                  {this.props.data.costDetails.parkingDuringCharging != null
                  ? roundToDecimals(this.props.data.costDetails.parkingDuringCharging, 2) + " €"
                  : "-"}
                  </td>
                  <td className="col">
                  {this.props.data.costDetails.parkingAmount != null
                  ? roundToDecimals(this.props.data.costDetails.parkingAmount, 2) + " €"
                  : "-"}
                  </td>
                </>
              ) : (
                <>
                  <td className="col">{this.props.data.totalTimeInMin || 0}</td>
                  <td className="col">
                    {!Number.isNaN(this.props.data.totalPower)
                      ? `${
                          this.props.data.totalPower < 1
                            ? `${roundToDecimals(
                                this.props.data.totalPower * 1000,
                                2
                              )}Wh`
                            : `${roundToDecimals(
                                this.props.data.totalPower,
                                2
                              )}kWh`
                        }`
                      : "-"}
                  </td>
                  {console.log(this.props.data)}

                  <td className="col">
                    {this.props.data.tariffsDetails?.opc?.total != null
                      ? roundToDecimals(this.props.data.tariffsDetails.opc.total, 2) + " €"
                      : "-"}
                  </td>
                  <td className="col">
                    {this.props.data.tariffsDetails?.opc?.activation != null
                      ? roundToDecimals(this.props.data.tariffsDetails.opc.activation, 2) + " €"
                      : "-"}
                  </td>
                  <td className="col">
                    {this.props.data.tariffsDetails?.opc?.time ?? "-"} €
                  </td>
                  <td className="col">
                    {this.props.data.tariffsDetails?.opc?.energy != null
                      ? roundToDecimals(this.props.data.tariffsDetails.opc.energy, 2) + " €"
                      : "-"}
                  </td>
                  <td className="col">
                    {this.props.data.tariffsDetails?.ceme?.total != null
                      ? roundToDecimals(this.props.data.tariffsDetails.ceme.total, 2) + " €"
                      : "-"}
                  </td>
                  <td className="col">
                    {this.props.data.tariffsDetails?.ceme?.activation != null
                      ? roundToDecimals(this.props.data.tariffsDetails.ceme.activation, 2) + " €"
                      : "-"}
                  </td>
                  <td className="col">
                    {this.props.data.tariffsDetails?.ceme?.time != null
                      ? roundToDecimals(this.props.data.tariffsDetails.ceme.time, 2) + " €"
                      : "-"}
                  </td>
                  <td className="col">
                    {this.props.data.tariffsDetails?.ceme?.energy != null
                      ? roundToDecimals(this.props.data.tariffsDetails.ceme.energy, 2) + " €"
                      : "-"}
                  </td>
                  <td className="col">
                    {this.props.data.tariffsDetails?.fees?.total != null
                      ? roundToDecimals(
                          this.props.withVat
                            ? this.props.data.tariffsDetails.fees.total
                            : (this.props.data.tariffsDetails.fees.total -
                                this.props.data.tariffsDetails.fees.iva) ||
                              0,
                          2
                        ) + " €"
                      : "-"}
                  </td>
                  <td className="col">
                    {this.props.data.tariffsDetails?.fees?.iec != null
                      ? roundToDecimals(this.props.data.tariffsDetails.fees.iec, 2) + " €"
                      : "-"}
                  </td>
                  <td className="col">
                    {this.props.data.tariffsDetails?.fees?.tar != null
                      ? roundToDecimals(this.props.data.tariffsDetails.fees.tar, 2) + " €"
                      : "-"}
                  </td>
                  <td className="col">
                    {this.props.data.tariffsDetails?.fees?.iva != null
                      ? roundToDecimals(
                          this.props.withVat ? this.props.data.tariffsDetails.fees.iva : 0,
                          2
                        ) + " €"
                      : "-"}
                  </td>
                </>
              )}
              <td className="col">
              {this.props.data.totalPrice?.[
                this.props?.withVat ? "incl_vat" : "excl_vat"
              ] ?? "-"}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    if (
      this.props.accountData !== null &&
      this.props.data !== null &&
      this.props.brand
    ) {
      const home =
        this.props.accountData.hasOwnProperty("places") &&
        Array.isArray(this.props.accountData.places) &&
        this.props.accountData.places.find((p) => p.name === "home");
      const address = home ? parseAddress(home.address).split(",") : "";
      return (
        <div id="report">
          <div className="letter-face">
            <img src={this.props.brand?.icons?.logo ?? evio} alt="" />
            <div className="sender-info">
              {this.props.brand?.additionalInformation?.address && (
                <p>{this.props.brand.additionalInformation.address}</p>
              )}
              {this.props.brand?.additionalInformation?.city && (
                <p>{this.props.brand.additionalInformation.city}</p>
              )}
              {this.props.brand?.additionalInformation?.mobile && (
                <p>{this.props.brand.additionalInformation.mobile}</p>
              )}
              {this.props.brand?.additionalInformation?.email && (
                <p>{this.props.brand.additionalInformation.email}</p>
              )}
            </div>
            <div className="recipient-info">
              <p>{this.props.accountData.name}</p>
              <p>
                {Array.isArray(address) && address.length > 0
                  ? address.shift().trim()
                  : ""}
              </p>
              <p>
                {Array.isArray(address) && address.length > 0
                  ? address.reduce((a, b) => a + b).trim()
                  : ""}
              </p>
            </div>
          </div>
          <div className="report-body">
            <div className="header">
              {this.renderTitle()}
              <div className="time-period">
                <img src={calendar} alt="" />
                <Translate value="report_timePeriod" />
                <span className="period">
                  {formatDate(this.props.data.startDate, "datetime")}
                </span>
              </div>
            </div>
          </div>
          <div className="report-body">{this.renderTable()}</div>
        </div>
      );
    } else return null;
  }
}

export default ReportDetail;
